(() => {
  const STORAGE_KEY = 'valleans_customer_zone_product_v2';
  const normalize = (value) => (value || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();

  function initCustomerZone(root) {
    if (!root || root.dataset.vhCzReady === 'true') return;
    root.dataset.vhCzReady = 'true';

    const products = [...root.querySelectorAll('[data-vh-cz-product]')];
    const tabs = [...root.querySelectorAll('[data-vh-cz-category]')];
    const search = root.querySelector('[data-vh-cz-search]');
    const clearSearch = root.querySelector('[data-vh-cz-search-clear]');
    const empty = root.querySelector('[data-vh-cz-empty]');
    const selectedEmpty = root.querySelector('[data-vh-cz-selected-empty]');
    const selectedProduct = root.querySelector('[data-vh-cz-selected-product]');
    const selectedImage = root.querySelector('[data-vh-cz-selected-image]');
    const selectedTitle = root.querySelector('[data-vh-cz-selected-title]');
    const selectedCategory = root.querySelector('[data-vh-cz-selected-category]');
    const productLink = root.querySelector('[data-vh-cz-product-link]');
    const manualLink = root.querySelector('[data-vh-cz-manual-link]');
    const noManual = root.querySelector('[data-vh-cz-no-manual]');
    const formProductSelects = [...root.querySelectorAll('[data-vh-cz-form-product]')];
    const claimReason = root.querySelector('[data-vh-cz-claim-reason]');
    const openClaimButtons = [...root.querySelectorAll('[data-vh-cz-open-claim]')];
    const claimDetails = root.querySelector('[data-vh-cz-claim-details]');
    const compactForms = [...root.querySelectorAll('.vh-cz-compact-form')];
    let activeCategory = 'all';

    function filterProducts() {
      const query = normalize(search?.value);
      let visible = 0;
      products.forEach((product) => {
        const matchesCategory = activeCategory === 'all' || product.dataset.productCategory === activeCategory;
        const haystack = normalize(`${product.dataset.productTitle || ''} ${product.dataset.productSearch || ''}`);
        const matchesSearch = !query || haystack.includes(query);
        const show = matchesCategory && matchesSearch;
        product.hidden = !show;
        if (show) visible += 1;
      });
      if (empty) empty.hidden = visible !== 0;
      if (clearSearch) clearSearch.hidden = !query;
    }

    function setCategory(category) {
      activeCategory = category || 'all';
      tabs.forEach((tab) => {
        const active = tab.dataset.vhCzCategory === activeCategory;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-pressed', String(active));
      });
      filterProducts();
    }

    function syncProductToForms(title) {
      formProductSelects.forEach((select) => {
        const option = [...select.options].find((item) => item.value === title);
        if (option) select.value = title;
      });
    }

    function syncUrl(handle) {
      if (!handle || !window.history?.replaceState) return;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('product', handle);
        window.history.replaceState({}, '', url);
      } catch (_) {}
    }

    function selectProduct(product, options = {}) {
      if (!product) return;
      products.forEach((item) => {
        const selected = item === product;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', String(selected));
      });

      const title = product.dataset.productTitle || '';
      const categoryLabel = product.dataset.productCategoryLabel || '';
      const image = product.dataset.productImage || '';
      const url = product.dataset.productUrl || '#';
      const manual = product.dataset.productManual || '';
      const handle = product.dataset.productHandle || '';

      if (selectedEmpty) selectedEmpty.hidden = true;
      if (selectedProduct) selectedProduct.hidden = false;
      if (selectedTitle) selectedTitle.textContent = title;
      if (selectedCategory) selectedCategory.textContent = categoryLabel;

      if (selectedImage) {
        const media = selectedImage.closest('.vh-cz-selected__media');
        if (image) {
          selectedImage.src = image;
          selectedImage.alt = title;
          media?.removeAttribute('hidden');
        } else {
          selectedImage.removeAttribute('src');
          selectedImage.alt = '';
          media?.setAttribute('hidden', '');
        }
      }

      if (productLink) productLink.href = url;
      if (manualLink) {
        if (manual) {
          manualLink.href = manual;
          manualLink.hidden = false;
          if (noManual) noManual.hidden = true;
        } else {
          manualLink.removeAttribute('href');
          manualLink.hidden = true;
          if (noManual) noManual.hidden = false;
        }
      }

      syncProductToForms(title);
      syncUrl(handle);
      try { if (handle) localStorage.setItem(STORAGE_KEY, handle); } catch (_) {}
      if (options.syncCategory) setCategory(product.dataset.productCategory || 'all');
      if (options.scroll) selectedProduct?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    tabs.forEach((tab) => tab.addEventListener('click', () => setCategory(tab.dataset.vhCzCategory || 'all')));
    products.forEach((product) => product.addEventListener('click', () => selectProduct(product, { scroll: true })));
    search?.addEventListener('input', filterProducts);
    search?.addEventListener('search', filterProducts);
    clearSearch?.addEventListener('click', () => {
      if (!search) return;
      search.value = '';
      search.focus();
      filterProducts();
    });

    openClaimButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const reason = button.dataset.claimReason || '';
        if (claimReason && [...claimReason.options].some((option) => option.value === reason)) claimReason.value = reason;
        if (claimDetails) claimDetails.open = true;
        claimDetails?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    compactForms.forEach((details) => {
      if (details.querySelector('.vh-cz-form__status')) details.open = true;
    });

    if (window.location.hash) {
      const target = root.querySelector(window.location.hash);
      if (target?.matches('details.vh-cz-compact-form')) target.open = true;
    }

    const params = new URLSearchParams(window.location.search);
    const requestedHandle = params.get('product');
    let restoredHandle = requestedHandle;
    if (!restoredHandle) {
      try { restoredHandle = localStorage.getItem(STORAGE_KEY); } catch (_) { restoredHandle = null; }
    }
    if (restoredHandle) {
      const restoredProduct = products.find((product) => product.dataset.productHandle === restoredHandle);
      if (restoredProduct) selectProduct(restoredProduct, { syncCategory: Boolean(requestedHandle) });
    }

    filterProducts();
  }

  const initAll = (scope = document) => scope.querySelectorAll('[data-vh-customer-zone]').forEach(initCustomerZone);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target || document));
})();
